export const FETCH_PAYMENT_STATUS_LIST_PENDING =
  'FETCH_PAYMENT_STATUS_LIST_PENDING';
export const FETCH_PAYMENT_STATUS_LIST_REJECTED =
  'FETCH_PAYMENT_STATUS_LIST_REJECTED';
export const FETCH_PAYMENT_STATUS_LIST_FULFILLED =
  'FETCH_PAYMENT_STATUS_LIST_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/paymentStatuses.js